import { defineComponent, ref } from 'vue'
import {
  Col as VanCol,
  Popup as VanPopup,
  Row as VanRow,
  showDialog,
  showToast,
} from 'vant'

// 1:1 复刻 49208 的 share 组件：
// - van-popup position="bottom"
// - 微信 / 朋友圈 / 短信 三个 icon-text
// - 微信、朋友圈点击：在微信内打开则提示"请点击顶端右上角分享吧"，否则提示"在微信里打开才能分享哦"
// - 短信使用 a[href="sms:?body=..."] 调起系统短信
// - 底部"取消"按钮
const ShareIconText = defineComponent({
  name: 'ShareIconText',
  props: {
    text: { type: String, required: true },
  },
  setup(props, { slots }) {
    return () => (
      <div class="icon-text">
        {slots.default?.()}
        <div class="text">{props.text}</div>
      </div>
    )
  },
})

export default defineComponent({
  name: 'SharePopup',
  setup(_, { expose }) {
    const show = ref(false)
    const text = ref('')

    function init() {
      if (!text.value) {
        text.value = `${document.title}：${location.href}`
      }
      show.value = true
    }

    function shareWeixin() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.includes('micromessenger')) {
        show.value = false
        showDialog({ message: '请点击顶端右上角分享吧' })
      } else {
        show.value = false
        showToast('在微信里打开才能分享哦')
      }
    }

    expose({ init })

    return () => (
      <div class="share">
        <VanPopup v-model:show={show.value} position="bottom">
          <div class="share-body">
            <VanRow>
              <VanCol span="8">
                <ShareIconText text="微信">
                  <button type="button" class="btn-reset" aria-label="微信" onClick={shareWeixin}>
                    <img src="/share-wechat.png" alt="" />
                  </button>
                </ShareIconText>
              </VanCol>
              <VanCol span="8">
                <ShareIconText text="朋友圈">
                  <button type="button" class="btn-reset" aria-label="朋友圈" onClick={shareWeixin}>
                    <img src="/share-moments.png" alt="" />
                  </button>
                </ShareIconText>
              </VanCol>
              <VanCol span="8">
                <a href={`sms:?body=${encodeURIComponent(text.value)}`}>
                  <ShareIconText text="短信">
                    <img src="/share-sms.png" alt="" />
                  </ShareIconText>
                </a>
              </VanCol>
            </VanRow>
            <button type="button" class="ft-btn van-hairline--top btn-block" onClick={() => (show.value = false)}>
              取消
            </button>
          </div>
        </VanPopup>
      </div>
    )
  },
})
